export enum InstantCheckupStatusBannerStateEnum {
  PHOTO_REVIEWED = 'photoReviewed',
  PHOTO_WILL_BE_REVIEWED = 'photoWillBeReviewed',
  PHOTO_REVIEW_PENDING = 'photoReviewPending'
}

export enum HeaderTypeEnum {
  SKIN_ANALYSIS_RESULT = 'SKIN_ANALYSIS_RESULT',
  HAIR_ANALYSIS_RESULT = 'HAIR_ANALYSIS_RESULT',
  DATE = 'DATE',
  CURESKIN_LOGO = 'CURESKIN_LOGO',
  DOCUMENT_VIEW = 'DOCUMENT_VIEW',
}

export enum ButtonVariant {
  PRIMARY = 'primary',     // Primary action button (teal background, white text)
  SECONDARY = 'secondary'  // Secondary action button (outlined, teal text)
}

export enum I18nKey {
  RE_TAKE_PHOTO = '@@reTakePhoto',
  CHECK_AGAIN = '@@checkAgain',
  RETAKE = '@@retake',
  CONTINUE = '@@continue',
  CHANGE = '@@change',
  SHARE_WITH_DOCTOR = '@@shareWithDoctor'
}

export enum FooterContainerVariant {
  DEFAULT = 'default',           // Standard layout
  SELF_CHECKUP = 'self-checkup' // Self-checkup banner layout
}

// Button metadata interface
export interface ButtonMetadata {
  variant: ButtonVariant;
  i18nKey: I18nKey;
  action: () => void | Promise<any>;
  shouldShow: boolean;  // Whether the button should be rendered
  cssClasses?: string;  // Additional CSS classes as a string
}

// Footer layout interface
export interface FooterLayout {
  buttons: ButtonMetadata[];
  containerVariant: FooterContainerVariant;
}

// Invalid photo error mapping experiment types
export enum InvalidPhotoUiCode {
  FALLBACK = 'FALLBACK',
  FACE_NOT_FOUND = 'FACE_NOT_FOUND',
  BLUR_IMAGE = 'BLUR_IMAGE',
  DARK_IMAGE = 'DARK_IMAGE',
}

export interface InvalidPhotoErrorMapping {
  errorMessage: string;
  uiCode: string;
}

export interface InvalidPhotoErrorMappingVariant {
  face_not_found: boolean;
  blur_face: boolean;
  lighting_issue: boolean;
  errorMappings: InvalidPhotoErrorMapping[];
}

export type InvalidPhotoCategoryKey = 'face_not_found' | 'blur_face' | 'lighting_issue';

export const UI_CODE_CATEGORY_MAP: Record<string, InvalidPhotoCategoryKey> = {
  [InvalidPhotoUiCode.FACE_NOT_FOUND]: 'face_not_found',
  [InvalidPhotoUiCode.BLUR_IMAGE]: 'blur_face',
  [InvalidPhotoUiCode.DARK_IMAGE]: 'lighting_issue',
};
